export const branchSurveyLinks = [
  {
    key: 'apex',
    label: 'Apex',
    cta: 'apex',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJOSiVccGSrIkRHyybcbhjK08',
  },
  {
    key: 'asheville',
    label: 'Asheville',
    cta: 'asheville',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJ1fC5yNH0WYgRHVZ2jHKiz0Y',
  },
  {
    key: 'atlantic',
    label: 'Atlantic',
    cta: 'atlantic',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJJadLLgZZrIkRb9YZXNr8kzw',
  },
  {
    key: 'ballantyne',
    label: 'Ballantyne',
    cta: 'ballantyne',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJ_TsB1DmdVogR3OP7lbmfx8o',
  },
  {
    key: 'cary',
    label: 'Cary',
    cta: 'cary',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJGf6yujjyrIkRjQrp_81rLtY',
  },
  {
    key: 'cary-towne-center',
    label: 'Cary Towne Center',
    cta: 'caryTowneCenter',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJm3n55rrzrIkRnCA7qFmGLK8',
  },
  {
    key: 'charleston',
    label: 'Charleston',
    cta: 'charleston',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJS2-p0V8yT4gRlOfdjbqQHSE',
  },
  {
    key: 'fayetteville',
    label: 'Fayetteville',
    cta: 'fayetteville',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJuw110Sxrq4kRpYa7caPqMr8',
  },
  {
    key: 'forest-acres',
    label: 'Forest Acres',
    cta: 'forestAcres',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJl39FpWuj-IgRxuke44SD0NA',
  },
  {
    key: 'fort-mill',
    label: 'Fort Mill',
    cta: 'fort',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJxQTrplyFVogRvnOVUGpoFIU',
  },
  {
    key: 'glenwood',
    label: 'Glenwood',
    cta: 'glenwood',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJmTkXmFX2rIkR7bXP2uB6oLk',
  },
  {
    key: 'huntersville',
    label: 'Huntersville',
    cta: 'huntersville',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJw5zO1wCpVogRQYSlbqTuamI',
  },
  {
    key: 'indian-land',
    label: 'Indian Land',
    cta: 'indianLand',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJIy5fQQCDVogRkm6sZa6-xx8',
  },
  {
    key: 'irmo',
    label: 'Irmo',
    cta: 'irmo',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJRbhog6WY-IgR--QkrOgSvHM',
  },
  {
    key: 'kildaire',
    label: 'Kildaire',
    cta: 'kildaire',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJ1_u7mDPzrIkRC3REK4Qw9TQ',
  },
  {
    key: 'matthews',
    label: 'Matthews',
    cta: 'matthews',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJxQla3eMjVIgRR6dJ75xR7wM',
  },
  {
    key: 'military-cutoff',
    label: 'Military Cutoff',
    cta: 'militaryCutoff',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJoxrEY2PzqYkRLKL7ScFCqqo',
  },
  {
    key: 'montford',
    label: 'Montford',
    cta: 'montford',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJJUVvQ2ueVogRepg6xWXljvk',
  },
  {
    key: 'mt-pleasant',
    label: 'Mt. Pleasant',
    cta: 'mtPleasant',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJsSD3ULYcIogRmeLH8hZxMPI',
  },
  {
    key: 'new-hope',
    label: 'New Hope',
    cta: 'newHope',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJIwDK8QBcrIkRm3AU3Zmk9LA',
  },
  {
    key: 'pineville',
    label: 'Pineville',
    cta: 'pineville',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJOzBovFmcVogRu0XBZLWX5BU',
  },
  {
    key: 'pisgah-church',
    label: 'Pisgah Church',
    cta: 'pisgahChurch',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJC1vkn1ceU4gRrDG6mo19fbQ',
  },
  {
    key: 'pleasantburg',
    label: 'Pleasantburg',
    cta: 'pleasantburg',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJN-MZFGguWIgRbHr6GioeDGk',
  },
  {
    key: 'rtp-durham',
    label: 'RTP Durham',
    cta: 'rtpDurham',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJGzHM9hHvrIkRaKE6v4h6Grg',
  },
  {
    key: 'south-end',
    label: 'South End',
    cta: 'southEnd',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJmzfEq8KeVogRpmchcRHEHzs',
  },
  {
    key: 'south-square',
    label: 'South Square',
    cta: 'southSquare',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJs33vo1nmrIkRW5PJBmhSapE',
  },
  {
    key: 'steele-creek',
    label: 'Steel Creek',
    cta: 'steeleCreek',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJHVxz54aQVogR4-1Zh8ieuMs',
  },
  {
    key: 'summerville',
    label: 'Summerville',
    cta: 'summerville',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJmR2n9iyM_ogRnWfjX_LRCLk',
  },
  {
    key: 'wt-harris',
    label: 'W.T. Harris',
    cta: 'wtHarris',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJW3oEODscVIgRBLAanWgmjwc',
  },
  {
    key: 'wake-forest',
    label: 'Wake Forest',
    cta: 'wakeForest',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJxZIXFhRRrIkRqELOjVP4ehw',
  },
  {
    key: 'wendover',
    label: 'Wendover',
    cta: 'wendover',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJOWusHCcbU4gRM7Q5mcT6wyQ',
  },

  {
    key: 'wilmington-oleander',
    label: 'Wilmington-Oleander',
    cta: 'wilmingtonOleander',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJ5wmG4KD1qYkR2mOhlK7x160',
  },
  {
    key: 'winston-salem',
    label: 'Winston-Salem',
    cta: 'winstonSalem',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJOT74Hs2xU4gRlVAlCQetjbs',
  },
  {
    key: 'woodruff',
    label: 'Woodruff',
    cta: 'woodruff',
    url:
      'https://search.google.com/local/writereview?placeid=ChIJwSPJ3cEoWIgRbe-nGoRhGr4',
  },
];
